import m from 'mithril'
import stream from 'mithril/stream'
import Dialog from 'components/dialog'
import ProfileDialog from './dialogs/profile'
import PasswordDialog from './dialogs/password'
import {
    User
} from 'app/models'


const clickEvent = (dom, toggle, e) => {
    if (!dom.contains(e.target)) {
        toggle(null)
        m.redraw()
    }
}

class Header {
    constructor(vnode) {
        this.menuToggle = vnode.attrs.navbarToggle
        this.toggle = stream()
    }

    oncreate(vnode) {
        document.addEventListener('click', clickEvent.bind(null, vnode.dom, this.toggle), false)
    }

    view(vnode) {
        return [
            m("div.headerbar",
                [
                    m("div.headerbar-left",
                        m("a.logo.d-md-flex.align-items-center.h-100[href='#'].pl-4.d-none",
                            [
                                m("img[alt='Logo']", {
                                    src: `${window.BASE_URL}/img/logo.png`,
                                    style: {
                                        maxHeight: "50px"
                                    }
                                })
                            ]
                        ),
                        m("a.logo.d-md-none.align-items-center.h-100[href='#'].pl-4.d-flex",
                            m("img[alt='Logo']", {
                                src: `${window.BASE_URL}/img/logo.png`,
                                style: {
                                    maxHeight: "40px"
                                }
                            })
                        ),
                    ),
                    m("nav.navbar-custom",
                        [
                            m("ul.list-inline.float-right.mb-0",
                                [
                                    // m("li.list-inline-item.dropdown.notif",
                                    //     [
                                    //         m("a.nav-link.dropdown-toggle.arrow-none[data-toggle='dropdown'][href='#'][role='button'][aria-haspopup='false'][aria-expanded='false']",
                                    //             m("i.fa.fa-fw.fa-question-circle")
                                    //         ),
                                    //     ]
                                    // ),
                                    m("li.list-inline-item.dropdown.notif", {
                                        class: this.toggle() == 'user' ? 'show' : ''
                                    },
                                        [
                                            m(".d-flex.align-items-stretch", [
                                                // m('.dropdown.d-flex', [
                                                //     m("button.btn.text-white.px-1 px-md-2", {
                                                //         style: {
                                                //             "background": "transparent"
                                                //         },
                                                //         onclick: (e) => {
                                                //             this.toggle('notifition')
                                                //         }
                                                //     },
                                                //         m("i.material-icons",
                                                //             "notifications_none"
                                                //         )
                                                //     ),
                                                //     m('.dropdown-menu.dropdown-menu-right.shadow', {
                                                //         class: this.toggle() == 'notifition' ? 'show' : ''
                                                //     }, [
                                                //             m('a.dropdown-item[href="#"]', '無資料')
                                                //         ])
                                                // ]),
                                                m('.dropdown.d-flex', [
                                                    m("a.btn.text-white.pt-1.pb-0", {
                                                        style: {
                                                            "background": "transparent"
                                                        },
                                                        onclick: (e) => {
                                                            this.toggle('user')
                                                        }
                                                    }, [
                                                        m("img.my-1[alt='使用者']", {
                                                            src: `data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADQAAAA0CAYAAADFeBvrAAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAADwAAAA8ABA9l7mgAAABl0RVh0U29mdHdhcmUAd3d3Lmlua3NjYXBlLm9yZ5vuPBoAAAYvSURBVGiB3ZpbrBXVGcd/a3sBFDy0eDlixVptDUclXlCrpjypRwlGE1588MmkTVNSTU2MGqPRB6NUIdVq2odWIyZtWg2RaOKlaDAqlxJjsF6IiIK2DQeVqwgSOL8+rDXMnO3ZZ8/MHiDpP9mZzFrr/11m9nxrre9bgQahDgBXADOA6cAZwNFtw/YCHwNrgTXA0hDCh03a0RPU89WF6r+tj8/VBep5vdoTajrRAq4H7gAuKnTtAZan33vAh8DXbfSJwABwDnA5cCkwrtC/CpgPLAkhDNexrxLUS9U1hae7W31GvVadUEPeBPU69Vl1T0HuO+olB8OHouLH1f1J4Xb1AfWkBnX0q/PVHUnHfvVRdXxTOjJFZ6vvJSXD6lPqiY0qGamvX3066VJ9V53elPBZ6W2oDqlXVuRPMwaO89VTK3IH1c1J91b18mrWf1fgVequJHCFOrUkb5r6iPrZKBFto/q7ss6pP1BXJe6uqg+0KGhQ/TYJ+ps6rgQnqLcWeGPhW/UWtWukVcclGzJeNafUAXVbErBEPbIk7+ESjrRjfknZR6nPJ84W9ayyzhxjHgCWWTLCqHNrOJPh+pI6JqhvJM4ay0wT6h8T4b+WjGTq0eqnPTj0idq+ROqkq1/dlHiPdRt8mTH2D6tXlFGQeIM9OJOhqr7hZOtFnQYF4+ys+ueywhN3QQMO/baizkWJ909HCyzG5YfGD25KReGvNODQSxV1nmg+P87O2luFMben6+MhhK+qCAdOqDh+NFRaeYQQNgN/SLd3jOhUz0uefmONJY36QQNv6P0aek8yX9CeC/kbuildFyfPq2J7DU47tlYlhBCGgOfS7U0ALeMHNTc1/qWmMWtr8or4qCbvr+k6F+Ibmg5MBXYBS2sKXVGTV8TKmryXgd3AqepZLWBW6lgeQthbU+hiYF9NLom7uA4xhLCH/IHOahETGtDDUw4hfNkLH1iVZNRFpntG9peD3r+DBT1wF/aoO7N9OsZ1lOrFPQpFfatGuO75+zPmOVQ/bgF9qX1br4KBu4AqmRqBuxvQuyVd+zDfjJXajXaDemeFt3NvQzqnJnl7UPemm5MbEt5SXyrhzDL1iIZ0HnCoBexM7ZOaEJ6Sg0+WGLoohLC/CZ3Acem6swXsSDeTGxIO+UMaC5sa1Pe9dN3eAtanm580qGAd8NkY/RuBDxrUl9m+vkW+hvpxLxKNG8Sr1UkhhHXABcBjwBeFYUPAI8CFIYQN6mQbmC7Ibf8I9Zfpg3qljiR1ojpPXZvk3NzWP9W4EdveHnjU2xLnbfUX6sSaNrya5Pwc9cx0s9sKyXb1WPUuY0aziBEJD/WFQt/zhfbxxjJKEdvUu6s4luzIpp7TssYswzm7Cz8bf7WjZ0UzzEvj5ozSNzv1/WYM/n/UOSVtyVIHnxQbH0yNf+9CPkJ9yDyJ3glfqieoq0fpW2XcaW7pIkNjtWPM9Ja6OI29v9g4IzV23IKrRxprOGWxZoy+dyvIWWqHZKcxR5dtwc9u73wzdTzYgfxoBSOaxhMdbMpSz6+P1jk7de5Q+9v6BswLXYcDw8aCdNGmU9SvU/+B5H0xjfUicRs8CWhP+v2sbeyhRkg2FPEQcCzwRgjhH1njASNDCAK/AvYDNzoyNVtrfmgYB2xQB4EbiFv3ecVBI556COEd4kwegEXmAaKX7XFT2AwxEABPEW1cGEL415gsYyUhC7fLjBPgFPPS4OHAkPp9R5ZTVqhHlXoU6o/ULxJxiTFkz1Q3HGJHNJYwZzqy4DVktiooC/Vc82XNq+pxxrd1m/m67WBinXq78a30qa+l9q3qOZWcKTh1pXloHFE0NubDf63+SV1pLJDVxZCxLPKEse46s6CnWDTeaZc6UpmC7SXAC8DxxA/zxmKYbBs7HugnBpu+dJ3cpmdr4SqwKYSwu4O8QeBpYnVjMzAnhLC6m81dYfym3k5P6XAcvFit/rBpJePV36v7kpJDcTRmn/FMQ9cjBb0ovcB83acH7/DS69Y4blbreFky5BrgHuCnhebseNlK4iG/9cTaUTGz1AecSTwceBnfPV62HLgvhFBrB90z/H84ANgJ5kc0B4DTgWnAlPQD+Cr9NgIbgPdp+Ijm/wDjxqdgc+UaZwAAAABJRU5ErkJggg==`,
                                                            style: {
                                                                width: '32px'
                                                            }
                                                        }),
                                                    ]),
                                                    m('.dropdown-menu.dropdown-menu-right.shadow', {
                                                        class: this.toggle() == 'user' ? 'show' : ''
                                                    }, [
                                                        m(".dropdown-item.notify-item.text-white.bg-default", {
                                                            onclick: (e) => {
                                                                e.preventDefault()
                                                            }
                                                        },
                                                            [
                                                                m("h5.text-overflow",
                                                                    m("small",
                                                                        m("i.mr-2.fa.fa-user-o"),
                                                                        m("span", window.USER_NAME),
                                                                        m('span', ' ,您好')
                                                                    )
                                                                ),

                                                            ]
                                                        ),

                                                        m("a.dropdown-item.notify-item[href='#']", {
                                                            onclick: (e) => {
                                                                e.preventDefault()

                                                                Dialog.show(PasswordDialog, {
                                                                    attrs: {
                                                                        model: new User(User.Account)
                                                                    },
                                                                    didHide: (returnValue) => {
                                                                        if (returnValue) {
                                                                            User.load()
                                                                        }
                                                                    }
                                                                })
                                                                this.toggle('')
                                                            }
                                                        },
                                                            [
                                                                m("i.mr-2.fa.fa-unlock"),
                                                                m("span",
                                                                    "修改密碼"
                                                                )
                                                            ]
                                                        ),
                                                        m("a.dropdown-item.notify-item", {
                                                            href: `${window.BASE_URL}/backend/logout`
                                                        },

                                                            [
                                                                m("i.mr-2.fa.fa-power-off"),
                                                                m("span",
                                                                    "登出"
                                                                )
                                                            ]
                                                        ),
                                                    ])
                                                ])
                                            ]),
                                        ]
                                    )
                                ]
                            ),
                            m("ul.list-inline.menu-left.mb-0",
                                m("li.float-left",
                                    m("button.button-menu-mobile.open-left", {
                                        // style:{
                                        //     zIndex: 2096
                                        // },
                                        onclick: (e) => {
                                            this.menuToggle(!this.menuToggle())
                                            // console.log(this.menuToggle())
                                            // vnode.attrs.width(0)
                                        }
                                    },
                                        m("i.fa.fa-fw.fa-bars")
                                    )
                                )
                            )
                        ]
                    )
                ]
            )
        ]
    }
}

export default Header